import { ProviderWarehouse, ProviderWarehouseDelivery, Warehouse } from 'src/typings';

export function deliveryForReceiver(
  warehouse: Pick<ProviderWarehouse, 'deliveryRoutes'> | null | undefined,
  receiverWarehouseId: number | null | undefined
): ProviderWarehouseDelivery | null {
  if (!receiverWarehouseId) return null;
  return (
    warehouse?.deliveryRoutes?.find((route) => route.receiverWarehouseId === receiverWarehouseId)
      ?.delivery || null
  );
}

export function initialReceiverWarehouseId(
  warehouses: Pick<Warehouse, 'id'>[],
  requested: string | null,
  defaultWarehouseId: number | null | undefined
): number | null {
  const id = requested === null ? defaultWarehouseId : Number(requested);
  return id && warehouses.some((warehouse) => warehouse.id === id) ? id : null;
}
